import type { components } from 'src/types/allApiTypes.gen';

export type OrgUnitSimple = components['schemas']['OrganisationalUnitSimple'];
export type OrgUnit = components['schemas']['OrganisationalUnit'];
export type ModulePermissionOrgUnit =
  components['schemas']['ModulePermissionOrgUnitTyped'];
export type PlanActionPermissionOrgUnit =
  components['schemas']['PlanActionModulePermissionOrgUnitTyped'];
export type ModuleOrPlanActionOrgUnit =
  components['schemas']['ModulePermissionOrgUnitPolymorphic'];
export const isPlanActionOrgUnit = (
  unit?: ModuleOrPlanActionOrgUnit,
): unit is PlanActionPermissionOrgUnit =>
  // eslint-disable-next-line no-prototype-builtins
  (unit as PlanActionPermissionOrgUnit)?.hasOwnProperty(
    'plan_action_due_date',
  ) === true;
